import React, { Component } from "react";
import { Box } from "@learningblocks/storybook-components";
import {HamburgerIcon} from "@learningblocks/storybook-components/lib/Icons";

import "react-toastify/dist/ReactToastify.css";


export class Graphics extends Component {
  constructor(props){
    super(props)
  }


  showMoveMenu(){
    this.props.setMoveMenu({
      component: "box",
      type: this.props.type,
      connect: this.props.id
    });
    this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
  };


  render() {
    return (
      <Box
        id={this.props.id}
        buttonList={[{image: HamburgerIcon, onClick: ()=>{this.showMoveMenu()} }]}
      />
    );
  }
}
